<template>
  <div class="notification-detail">
    <h2>全体連絡 詳細</h2>
    <NotificationEditor :notificationId="notificationId" />
  </div>
</template>

<script>
import NotificationEditor from '@/components/Ctrl/NotificationDetail/NotificationEditor.vue';

export default {
  name: 'NotificationDetail',
  components: {
    NotificationEditor
  },
  props: {
    notificationId: {
      type: String,
      required: true
    }
  },
};
</script>

<style scoped>
.notification-detail {
  padding: 24px;
}
</style>